import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=0c8bd7b6&scoped=true&"
import script from "./ProgressBar.vue?vue&type=script&lang=ts&"
export * from "./ProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=0c8bd7b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8bd7b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0c8bd7b6', component.options)
    } else {
      api.reload('0c8bd7b6', component.options)
    }
    module.hot.accept("./ProgressBar.vue?vue&type=template&id=0c8bd7b6&scoped=true&", function () {
      api.rerender('0c8bd7b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/learningPathV2/ProgressBar.vue"
export default component.exports